import {
  Link as ArrowLeft,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import SelectBuscable from '@/shared/components/SelectBuscable'
import { estiloDeBoton } from '@/shared/lib/estilosDeBoton'

const CreateInvitationsPage = () => {
  const navigate = useNavigate();
  const [tipoServicio, setTipoServicio] = useState("");
  return (
    <div className="min-h-screen bg-white p-6">
      <div className="max-w-7xl mx-auto">
        <div className="min-h-screen bg-white p-6">
          <div className="max-w-7xl mx-auto">
            {/* Header */}
            <div className="mb-6">
              <div className="flex item-start gap-2 mb-2">
                <div className="flex items-start">
                  <button
                    onClick={() => navigate(-1)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <ArrowLeft className="w-5 h-5" />
                  </button>
                  <span className="text-sm text-gray-600">Volver</span>
                </div>
                <div className="ml-4">
                  <h1 className="text-2xl font-bold text-[#1A1A1A]">
                    Crear invitación
                  </h1>
                  <p className="text-[#666666]">
                    Llena los datos del siguiente formulario para crear una
                    invitación de proveedor.
                  </p>
                </div>
              </div>
            </div>

            {/* Form */}
            <form className="space-y-6">
              {/* Información del usuario */}
              <div className="bg-white border border-[#E0E0E0] rounded-lg">
                <h3 className="text-lg font-semibold text-[#1A1A1A] mb-6 pb-4 border-b border-[#E0E0E0] p-6">
                  Datos generales
                </h3>
                <div className="grid grid-cols-2 gap-4 mt-6 p-6">
                  <div>
                    <label className="block text-sm font-medium text-[#2C2C2C] mb-2">
                      Razón social<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Ingresa Razón social"
                      className="w-full px-4 py-2.5 bg-[#f5f9fb] border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 placeholder:text-gray-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#2C2C2C] mb-2">
                      Nombre comercial 
                    </label>
                    <input
                      type="text"
                      placeholder="Ingresa Nombre comercial"
                      className="w-full px-4 py-2.5 bg-[#f5f9fb] border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 placeholder:text-gray-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#2C2C2C] mb-2">
                      RFC 
                    </label>
                    <input
                      type="text"
                      placeholder="Ingresa el RFC"
                      className="w-full px-4 py-2.5 bg-[#f5f9fb] border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 placeholder:text-gray-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#2C2C2C] mb-2">
                      Tipo de servicio 
                    </label>
                    <SelectBuscable
                      variante="formulario"
                      opciones={[]}
                      value={tipoServicio}
                      onChange={setTipoServicio}
                      placeholder="Seleccionar"
                      placeholderDeBusqueda="Buscar tipo de servicio..."
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#2C2C2C] mb-2">
                      Contacto principal 
                    </label>
                    <input
                      type="text"
                      placeholder="0000000000"
                      className="w-full px-4 py-2.5 bg-[#f5f9fb] border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 placeholder:text-gray-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#2C2C2C] mb-2">
                      Correo de contacto 
                    </label>
                    <input
                      type="email"
                      placeholder="Ej. jose@example.com"
                      className="w-full px-4 py-2.5 bg-[#f5f9fb] border-0 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 placeholder:text-gray-400"
                    />
                  </div>
                </div>
              </div>
              {/* Footer */}
              <div className="flex justify-end gap-3 mt-6">
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className={estiloDeBoton('secundario')}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className={estiloDeBoton('primario')}
                >
                  Enviar a pre-valoración
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateInvitationsPage;
